<template>
  <!-- 管理员首页：欢迎区 + 快捷入口 -->
  <div class="home">
    <!-- 欢迎横幅 -->
    <section class="hero">
      <div class="hero__text">
        <h2 class="hero__title">{{ greeting }}，{{ name }}</h2>
        <p class="hero__desc">云伴展后台管理系统，请从下方快捷入口或左侧菜单进入对应功能。</p>
      </div>
      <div class="hero__date">
        <span class="hero__date-day">{{ today.monthDay }}</span>
        <span class="hero__date-week">{{ today.week }}</span>
      </div>
    </section>

    <!-- 参观登记 / 意向登记 / 展商登记数据 -->
    <section class="kpi-row">
      <div class="kpi" @click="go('/admin/viewerlist?type=1')" title="查看参观登记列表">
        <div class="kpi__icon kpi__icon--visit">
          <i class="el-icon-view"></i>
        </div>
        <div class="kpi__main">
          <div class="kpi__num">{{ formatNum(visitCount) }}</div>
          <div class="kpi__label">参观登记数</div>
        </div>
        <i class="el-icon-arrow-right kpi__arrow"></i>
      </div>

      <div class="kpi" @click="go('/admin/accountmanage?type=2')" title="查看意向登记列表">
        <div class="kpi__icon kpi__icon--apply">
          <i class="el-icon-tickets"></i>
        </div>
        <div class="kpi__main">
          <div class="kpi__num">{{ formatNum(applyCount) }}</div>
          <div class="kpi__label">意向登记数</div>
        </div>
        <i class="el-icon-arrow-right kpi__arrow"></i>
      </div>

      <div class="kpi" @click="go('/admin/ex_user')" title="查看展商登记列表">
        <div class="kpi__icon kpi__icon--exhibitor">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="kpi__main">
          <div class="kpi__num">{{ formatNum(exhibitorCount) }}</div>
          <div class="kpi__label">展商登记数</div>
        </div>
        <i class="el-icon-arrow-right kpi__arrow"></i>
      </div>
    </section>

    <!-- 快捷入口 -->
    <section class="panel">
      <header class="panel__header">
        <h3 class="panel__title">快捷入口</h3>
      </header>
      <div class="entry-grid">
        <div
          v-for="item in entries"
          :key="item.path"
          class="entry"
          @click="go(item.path)"
        >
          <div class="entry__icon">
            <i :class="item.icon"></i>
          </div>
          <div class="entry__main">
            <div class="entry__name">{{ item.name }}</div>
            <div class="entry__desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "adminIndex",
  data() {
    return {
      /** 当前登录账号名 */
      name: localStorage.getItem("name") || "管理员",
      /** 参观登记数 */
      visitCount: 0,
      /** 意向登记数 */
      applyCount: 0,
      /** 展商登记数 */
      exhibitorCount: 0,
      /** 快捷入口配置，全部对应侧边栏已有页面 */
      entries: [
        { name: "论坛活动", desc: "活动信息与报名", icon: "el-icon-date", path: "/admin/activitylist" },
        { name: "展会管理", desc: "介绍 / 安排 / 交通 / 资料", icon: "el-icon-office-building", path: "/admin/eventinfo?type=1" },
        { name: "参观参展", desc: "参观 / 参展 / 展商登记", icon: "el-icon-user", path: "/admin/viewerlist?type=1" },
        { name: "新闻报道", desc: "小程序端与展商端资讯", icon: "el-icon-document", path: "/admin/eventmanage?type=1" },
        { name: "广告管理", desc: "首页轮播与广告位", icon: "el-icon-picture", path: "/admin/admanage" },
        { name: "小程序用户", desc: "用户列表与详情", icon: "el-icon-phone", path: "/admin/wxuser" },
        { name: "反馈信息", desc: "用户留言与建议", icon: "el-icon-chat-dot-round", path: "/admin/newlist" },
        { name: "获取短链接", desc: "生成分享短链", icon: "el-icon-link", path: "/admin/short_link" },
      ],
    };
  },
  mounted() {
    this.getVisitCount();
    this.getApplyCount();
    this.getExhibitorCount();
  },
  computed: {
    /** 按当前时间给出问候语 */
    greeting() {
      let h = new Date().getHours();
      if (h < 6) return "凌晨好";
      if (h < 12) return "早上好";
      if (h < 14) return "中午好";
      if (h < 18) return "下午好";
      return "晚上好";
    },
    /** 今日日期 */
    today() {
      let d = new Date();
      let weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      return {
        monthDay: `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`,
        week: weeks[d.getDay()],
      };
    },
  },
  methods: {
    /**
     * 获取参观登记总数
     * 只取分页的 count，size=1 减少返回体积
     */
    getVisitCount() {
      let url = this.baseUrl + "/admin/visits/?page=1&size=1";
      api.fetchData(url).then((res) => {
        this.visitCount = res.count || 0;
      });
    },

    /**
     * 获取意向登记总数
     * 对应后台「参观参展 - 意向登记」列表
     */
    getApplyCount() {
      let url = this.baseUrl + "/admin/applys/?page=1&size=1";
      api.fetchData(url).then((res) => {
        this.applyCount = res.count || 0;
      });
    },

    /**
     * 获取展商登记总数
     * 对应后台「参观参展 - 展商登记」列表
     */
    getExhibitorCount() {
      let url = this.baseUrl + "/admin/exhibitors/?page=1&size=1";
      api.fetchData(url).then((res) => {
        this.exhibitorCount = res.count || 0;
      });
    },

    /** 数字千分位展示，空值兜底为 0 */
    formatNum(val) {
      if (val === null || val === undefined || val === "") return 0;
      let num = Number(val);
      if (isNaN(num)) return val;
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    /** 跳转到指定页面 */
    go(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.home {
  padding: var(--spacing-lg);
  box-sizing: border-box;
}

/* ===== 欢迎横幅 ===== */
.hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-lg);
  padding: var(--spacing-xl) var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
  background: linear-gradient(135deg, #e8f2ff 0%, #f5f9ff 60%, #ffffff 100%);
  border: 1px solid #dbeafe;
  border-radius: var(--radius-lg);
}

.hero__title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--text-primary);
}

.hero__desc {
  margin: var(--spacing-sm) 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary);
}

.hero__date {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--spacing-xs);
}

.hero__date-day {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-primary);
}

.hero__date-week {
  font-size: 13px;
  color: var(--text-secondary);
}

/* ===== 参观 / 参展数据 ===== */
.kpi-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
}

.kpi {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
  padding: var(--spacing-lg);
  background: var(--card-bg);
  border: 1px solid transparent;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  transition: all 0.2s;
}

.kpi:hover {
  border-color: var(--color-primary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.kpi__arrow {
  margin-left: auto;
  font-size: 14px;
  color: var(--text-muted);
  transition: all 0.2s;
}

.kpi:hover .kpi__arrow {
  color: var(--color-primary);
  transform: translateX(2px);
}

.kpi__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: var(--radius-md);
  font-size: 24px;
}

.kpi__icon--visit {
  color: #1a73e8;
  background: #e8f2ff;
}

.kpi__icon--apply {
  color: #0f9d8a;
  background: #e6f7f4;
}

.kpi__icon--exhibitor {
  color: #b26a00;
  background: #fdf3e6;
}

.kpi__main {
  min-width: 0;
}

.kpi__num {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.15;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.kpi__label {
  margin-top: var(--spacing-xs);
  font-size: 13px;
  color: var(--text-secondary);
}

/* ===== 面板 ===== */
.panel {
  background: var(--card-bg);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.panel__header {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 var(--spacing-lg);
  border-bottom: 1px solid var(--border-color);
}

.panel__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

/* ===== 快捷入口网格 ===== */
.entry-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--spacing-md);
  padding: var(--spacing-lg);
}

.entry {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-md);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.2s;
}

.entry:hover {
  border-color: var(--color-primary);
  background: var(--color-primary-light, #ecf5ff);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.entry__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  background: var(--color-primary-light, #ecf5ff);
  color: var(--color-primary);
  font-size: 20px;
}

.entry:hover .entry__icon {
  background: var(--color-primary);
  color: #fff;
}

.entry__main {
  min-width: 0;
}

.entry__name {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.entry__desc {
  margin-top: 2px;
  font-size: 12px;
  line-height: 18px;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ===== 响应式 ===== */
@media screen and (max-width: 1280px) {
  .entry-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media screen and (max-width: 900px) {
  .entry-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 640px) {
  .hero {
    flex-direction: column;
    align-items: flex-start;
  }
  .hero__date {
    align-items: flex-start;
  }
  .kpi-row {
    grid-template-columns: 1fr;
  }
  .entry-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/index.vue